import { useEffect, useRef, useState } from "react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Fetches GeoNet quakes from our backend proxy, on a polling interval.
export function useQuakes({ intervalMs = 45_000, mmi = 3 } = {}) {
  const [data, setData] = useState({
    quakes: [],
    latest: null,
    max_magnitude: null,
    fetched_at: null,
    loading: true,
    error: null,
  });
  const timer = useRef(null);
  const mounted = useRef(true);

  const load = async () => {
    try {
      const res = await axios.get(`${API}/quakes`, { params: { mmi } });
      if (!mounted.current) return;
      setData({
        quakes: res.data.quakes || [],
        latest: res.data.latest || null,
        max_magnitude: res.data.max_magnitude,
        fetched_at: res.data.fetched_at,
        loading: false,
        error: null,
      });
    } catch (e) {
      if (!mounted.current) return;
      setData((d) => ({ ...d, loading: false, error: e.message || String(e) }));
    }
  };

  useEffect(() => {
    mounted.current = true;
    load();
    timer.current = setInterval(load, intervalMs);
    return () => {
      mounted.current = false;
      if (timer.current) clearInterval(timer.current);
    };
  }, [intervalMs, mmi]);

  return { ...data, refresh: load };
}
